// extracted by mini-css-extract-plugin
export default {"empty":"GeneralOverview_empty__zg1Me","title":"GeneralOverview_title__wUgP0","subtitle":"GeneralOverview_subtitle__QPR4X"};